function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import withGradient from '../../withGradient';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Index = function Index(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      etc = _objectWithoutProperties(_ref, ["color", "size"]);

  return ___EmotionJSX("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, etc), etc.children, ___EmotionJSX("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28,8 C34.627417,8 40,13.372583 40,20 C40,26.627417 34.627417,32 28,32 C21.372583,32 16,26.627417 16,20 C16,13.372583 21.372583,8 28,8 Z M34.1664306,15.2118811 C33.6172558,14.6627063 32.7268675,14.6627063 32.1776927,15.2118811 L32.1776927,15.2118811 L25.6148579,21.7747159 L23.8249939,19.9848519 C23.2758191,19.4356771 22.3854308,19.4356771 21.8362561,19.9848519 C21.2870813,20.5340266 21.2870813,21.4244149 21.8362561,21.9735897 L21.8362561,21.9735897 L24.620489,24.7578226 C25.1696638,25.3069974 26.060052,25.3069974 26.6092268,24.7578226 L26.6092268,24.7578226 L34.1664306,17.2006189 C34.7156053,16.6514441 34.7156053,15.7610559 34.1664306,15.2118811 Z",
    transform: "translate(-16 -8)"
  }));
};

export default withGradient(Index);